import axios from "axios";
import { getCurrentUrl } from "src/constants/business-backend-urls";

const axiosBusinessApi = axios.create({
    baseURL: getCurrentUrl().backend,
    withCredentials: true,
    headers: {
        "X-Client-TimeZone": Intl.DateTimeFormat().resolvedOptions().timeZone,
        "tz-api-key": process.env.REACT_APP_TZ_API_KEY,
    },
});

export default axiosBusinessApi;
